export default __webpack_public_path__ + "static/media/water-colored.bc648d2e.svg";